import { principles, siteName, siteSlogan } from "@/mocks/gossip";

const voices = [
  {
    quote:
      "期末周全靠热搜榜解压，看到有人和我一样在图书馆占不到座，心里平衡了（不是）。",
    who: "大三 · 一枚爱刷瓜的同学",
  },
  {
    quote:
      "投稿过一条暖瓜，收到大家好多点赞，原来我身边的善意也能被这么多人看见。",
    who: "大一 · 暖瓜投稿人",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-100 px-3 py-1 text-[11px] font-medium text-primary-700">
              <i className="ri-community-line"></i> 关于我们
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              记录真实校园，传播温暖瞬间
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              {siteName} 是一个由校园内容爱好者共同维护的轻娱乐资讯平台，slogan 是「{siteSlogan}」。我们相信，校园里那些被写在朋友圈和表白墙上的小事，往往最真实也最好看——无论是让人会心一笑的名场面，还是偷偷努力的小温暖。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              我们的定位很简单：把散落在各个角落的校园爆料、八卦新鲜事与事件追踪汇聚成一份「每天都能看懂」的瓜报，让每个人在下课、排队、自习间隙，轻松抓住今天校园里正在发生的话题。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
              <div className="rounded-xl border border-background-200 bg-background-50 px-3 py-3 text-center">
                <div className="font-heading text-lg font-bold text-primary-600">
                  40+
                </div>
                <div className="mt-0.5 text-[11px] text-foreground-500">校园话题源</div>
              </div>
              <div className="rounded-xl border border-background-200 bg-background-50 px-3 py-3 text-center">
                <div className="font-heading text-lg font-bold text-primary-600">
                  3000+
                </div>
                <div className="mt-0.5 text-[11px] text-foreground-500">每周热帖</div>
              </div>
              <div className="rounded-xl border border-background-200 bg-background-50 px-3 py-3 text-center">
                <div className="font-heading text-lg font-bold text-primary-600">
                  96%
                </div>
                <div className="mt-0.5 text-[11px] text-foreground-500">上墙核对率</div>
              </div>
              <div className="rounded-xl border border-background-200 bg-background-50 px-3 py-3 text-center">
                <div className="font-heading text-lg font-bold text-primary-600">
                  匿名
                </div>
                <div className="mt-0.5 text-[11px] text-foreground-500">投稿保护</div>
              </div>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {principles.map((p, i) => (
              <div
                key={p.title}
                className={`rounded-2xl border p-5 ${
                  i % 2 === 0
                    ? "border-accent-200 bg-accent-50"
                    : "border-primary-200 bg-primary-50"
                }`}
              >
                <span
                  className={`inline-flex h-9 w-9 items-center justify-center rounded-xl text-lg ${
                    i % 2 === 0
                      ? "bg-accent-100 text-accent-800"
                      : "bg-primary-100 text-primary-700"
                  }`}
                >
                  {["ri-shield-check-line", "ri-lock-line", "ri-emotion-happy-line", "ri-refresh-line"][i]}
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                  {p.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {p.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* 口碑 */}
        <div className="mt-12 grid gap-4 md:grid-cols-2">
          {voices.map((v) => (
            <figure
              key={v.who}
              className="rounded-2xl border border-background-200 bg-background-50 p-6 shadow-soft"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                {v.quote}
              </blockquote>
              <figcaption className="mt-4 text-xs font-medium text-foreground-500">
                — {v.who}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}